import React from "react";
import EPaper from "./Components/EPaper";

const EPaperIndex: React.FC = () => {
  return <EPaper />;
};

export default EPaperIndex;
